import React from "react";
import classnames from "classnames";
import styles from "./Skeleton.module.scss";

type SkeletonProps = {
    "data-cy"?: string;
    height?: string;
    shape?: "rectangle";
    width?: string;
    className?: string;
};
export const Skeleton = ({
    shape = "rectangle",
    width = "120px",
    height = "40px",
    className = "display--block",
    ...props
}: SkeletonProps) => {
    const classes = classnames(styles["skeleton"], {
        [styles["skeleton--rectangle"]]: shape === "rectangle",
        "display--block": !className?.includes("display--block")
    });
    return (
        <span
            data-testid={props["data-cy"] || "skeleton"}
            data-cy={props["data-cy"] || "skeleton"}
            className={`${classes} ${className}`}
            style={{ width, height }}
        ></span>
    );
};
